import PropTypes from 'prop-types'

const ReservationPaymentDetailsInfo = ({ label, value, highlightKey = false }) => {
  return (
    <div className="reservation-summary-sidebar__payment-details-info">
      <div
        className={`reservation-summary-sidebar__payment-details-key${
          highlightKey ? '-highlighted' : ''
        }`}
      >
        {label}
      </div>
      <div className="reservation-summary-sidebar__payment-details-value">{value}</div>
    </div>
  )
}

ReservationPaymentDetailsInfo.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  highlightKey: PropTypes.bool,
}

export default ReservationPaymentDetailsInfo
